import { getLanguageCodeByLocale as e } from "../translations/language-utils.mjs";
import { CountryEnum as t, LocaleEnum as n } from "@systemeio/types";
import r from "i18n-iso-countries";
//#region src/countries/get-country-data.ts
var i = (e, t) => {
	try {
		return new Intl.DisplayNames([e], { type: "region" }).of(t);
	} catch {
		return;
	}
}, a = "Canary Islands", o = (n, o) => {
	let s = e(o);
	switch (n) {
		case t.Taiwan: return r.getName(n, s, { select: "alias" }) ?? n;
		case t.CanaryIslands: return i(s, n) ?? a;
		default: return r.getName(n, s, { select: "official" }) ?? n;
	}
}, s = (e = n.ENGLISH) => Object.values(t).map((t) => ({
	id: t,
	caption: o(t, e)
}));
//#endregion
export { s as getCountryData, o as getCountryName };
